import { useCallback } from 'react'

import { useBucket } from '@mc/experiments-react'
import { paths } from '@mc/paths'
import { useStaticData } from '@mc/static-data-react'
import { trackExperimentViewed } from '@mc/track-event'

import { GLOBAL_TEST_PURCHASE_CTA_COPY_EXPERIMENT_NAME } from './constants'

export const usePurchaseCtaCopyExperiment = () => {
  const bucket = useBucket(GLOBAL_TEST_PURCHASE_CTA_COPY_EXPERIMENT_NAME)
  const { pathname } = useStaticData<{ pathname?: string }>()
  const isQuizResultsPage = pathname === paths.classRecommendationsResults
  const isPurchaseCtaCopyVariant =
    bucket?.includes('variant') && !isQuizResultsPage
  const purchaseCopyKey = isPurchaseCtaCopyVariant
    ? 'pen-4993_v2.cta'
    : 'cta.getMasterclass'

  const trackPurchaseCtaExperiment = useCallback(() => {
    trackExperimentViewed(GLOBAL_TEST_PURCHASE_CTA_COPY_EXPERIMENT_NAME)
  }, [])

  return {
    purchaseCopyKey,
    trackPurchaseCtaExperiment,
  }
}
